// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LocalizationService {
   $location: any
   $timeout: any
   $window: any
   appState: any
   configService: any
   events: any
   localization: any
   mappings: any
   translationService: any
   urlService: any
   constructor(appState: any, urlService: any, configService: any, events: any, $window: any, $timeout: any, $location: any, translationService: any) {
      this.getStandardLocale = this.getStandardLocale.bind(this)
      this.setLocalization = this.setLocalization.bind(this)
      this.setLocale = this.setLocale.bind(this)
      this.reload = this.reload.bind(this)
      this.createNewPath = this.createNewPath.bind(this)
      this.appState = appState
      this.urlService = urlService
      this.configService = configService
      this.events = events
      this.$window = $window
      this.$timeout = $timeout
      this.$location = $location
      this.translationService = translationService
      this.localization = this.setLocalization()
      // FIXME: make summon use proper locale names when we obsolete Summon 1.0
      this.mappings = this.$window.__localeMap
   }

   getStandardLocale(locale = this.$window.__summonLocale) {
      if (this.mappings[locale] != null) { return this.mappings[locale] } else { return locale }
   }

   setLocalization() {
      const locale = this.$window.__summonLocale
      const localeConfig = this.configService.data.localization

      const languages = angular.copy(localeConfig.languages)
      languages.forEach((language: any) => {
         language.text = this.translationService.translate(language.name)
         return language.click = `localization.setLocale('${language.locale}')`
      })
      let current = _(languages).find((lang: any) => lang.locale === locale)
      if (!current) { current = _(languages).find((lang: any) => lang.locale === localeConfig.defaultLanguage) }
      if (!current) { current = languages[0] }
      if (!current) { current =  {
         locale: 'en',
         text: 'English'
      } }

      // RTL Languages: Arabic 'ar-AR', Hebrew 'he-HE', Farci 'fa-FA'
      const rtlLanguages = ['ar-AR', 'he-HE', 'fa-FA']
      const textDirection = _.contains(rtlLanguages, current.locale) ? 'rtl' : 'ltr'

      const l10n = {
         current,
         languages,
         setLocale: this.setLocale,
         dir: textDirection,
         isRTL: textDirection === 'rtl' ? true : false
      }

      return l10n
   }

   setLocale(locale: any) {
      const queryParams = this.$location.search()
      if (queryParams['l']) { delete queryParams['l'] }
      // TODO: find a way to do this without jQuery
      let qs = $.param(queryParams)
      if (!!qs.length) { qs = `?${qs}` }
      this.events.publish("actions", "language:switch", {locale})
      return this.reload(this.createNewPath(locale, qs))
   }

   reload(newUrl: any) {
      return this.$window.location.assign(newUrl)
   }

   // add locale specifier to path and let that handle setting the location param - SUM-66813 and CDI-31549
   // // place hashbang before '/library_card' and '/course_reserves' to avoid 404
   createNewPath(locale: any, qs: any) {
   const pathString = this.$location.path();
   let newPath = pathString;
   let specialRouteString = '';

   const exceptionalRoutes = [
      '/library_card',
      '/course_reserves'
   ];

   const matchedRoute = exceptionalRoutes.find(route => pathString.startsWith(route));
   if (matchedRoute) {
      newPath = pathString.slice(matchedRoute.length);
      specialRouteString = `#!${matchedRoute}${qs}`;
   }

   return `/${locale}${newPath}${qs}${specialRouteString}`;
}


}


LocalizationService.$inject = ['appStateService', 'urlService', 'configService', 'eventService', '$window', '$timeout', '$location', 'translationService']

angular.module('summonApp.services')
   .service('localizationService', LocalizationService)

